window.sipitInitOurStoryProgress = function sipitInitOurStoryProgress() {
  var root = document.querySelector('.sipit-our-story');
  if (!root || root.dataset.sipProgressReady === 'true') return;
  root.dataset.sipProgressReady = 'true';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fadeEls = root.querySelectorAll('.fade-up');
  if (reduce) {
    fadeEls.forEach(function (el) { el.classList.add('in'); });
    root.querySelectorAll('video').forEach(function (video) {
      video.pause();
      video.removeAttribute('autoplay');
    });
  } else if ('IntersectionObserver' in window) {
    var fadeIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('in');
      });
    }, { threshold: 0.12 });
    fadeEls.forEach(function (el) { fadeIo.observe(el); });
  } else {
    fadeEls.forEach(function (el) { el.classList.add('in'); });
  }

  var bar = root.querySelector('.sip-progress');
  var fill = root.querySelector('.sip-progress__fill');
  var track = root.querySelector('.sip-progress__track');
  var nodes = root.querySelectorAll('[data-node]');
  if (!bar || !fill || !track) return;

  document.body.appendChild(bar);

  var dots = [];
  nodes.forEach(function () {
    var dot = document.createElement('span');
    dot.className = 'sip-progress__dot';
    track.appendChild(dot);
    dots.push(dot);
  });

  var running = false;

  function pctNow() {
    var rect = root.getBoundingClientRect();
    var total = Math.max(1, root.offsetHeight - window.innerHeight * 0.35);
    var scrolled = -rect.top + 80;
    return Math.min(1, Math.max(0, scrolled / total));
  }

  function update() {
    var pct = pctNow();
    fill.style.height = (pct * 100).toFixed(2) + '%';

    var rootRect = root.getBoundingClientRect();
    var height = Math.max(1, root.offsetHeight);
    nodes.forEach(function (node, i) {
      var nodeRect = node.getBoundingClientRect();
      var nodePct = (nodeRect.top - rootRect.top) / height;
      dots[i].style.top = (Math.min(0.98, Math.max(0.02, nodePct)) * 100).toFixed(2) + '%';
      if (pct >= nodePct - 0.01) dots[i].classList.add('is-lit');
      else dots[i].classList.remove('is-lit');
    });
  }

  function loop() {
    if (!running) return;
    update();
    requestAnimationFrame(loop);
  }

  function start() {
    if (running) return;
    running = true;
    requestAnimationFrame(loop);
  }

  function stop() {
    running = false;
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries[0] && entries[0].isIntersecting) start();
      else stop();
    }, { threshold: 0 });
    io.observe(root);
  } else {
    start();
  }

  window.addEventListener('resize', update);
  document.addEventListener('scroll', update, { capture: true, passive: true });
  window.addEventListener('scroll', update, { passive: true });
  update();
  start();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.sipitInitOurStoryProgress);
} else {
  window.sipitInitOurStoryProgress();
}
